// webinar-access.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WebinarAccessService {
  private storageKey = 'webinarAccess';

  constructor() {}

  // ✅ Check access
  hasAccess(): boolean {
    return !!sessionStorage.getItem(this.storageKey);
  }

  // ✅ Grant access
  grantAccess(): void {
    sessionStorage.setItem(this.storageKey, 'true');
  }

  // ✅ Revoke access
  revokeAccess(): void {
    sessionStorage.removeItem(this.storageKey);
  }
  
}
